<template>
  <div class="container-fluid">

    <div class="row dataTable-filters orderlines-dt-filter">

    </div>

    <div class="table-responsive">

      <datatables
          :columns="getColumns()"
          ref="usersTable"
          :rows="users"
          :tableClass="tableClass"
          :tableInitOptions="tableInitOptions"
          deleteClass="delete"
          :key="'users-tb' "
          :customFilters="[]"
          tableID="users-dt"

      />
      <p v-if="!users.length">Loading users..</p>

    </div>
  </div>
</template>


<script>
import {mapGetters} from 'vuex';
import dataTables from '../../mixins/datatables';
import {nl} from 'vuejs-datepicker/dist/locale';


export default {
  name: 'teamlead-users',
  components: {},
  mixins: [dataTables],
  data() {
    return {
      users: [],
      nl: nl,

      tableClass: 'table-striped table-bordered     responsive nowrap',
      tableInitOptions: {
        stateSave: true,
        language: {
          "lengthMenu": "_MENU_ resultaten weergeven",
          "zeroRecords": "Geen resultaten gevonden",
          "infoEmpty": "Geen resultaten om weer te geven",
          "search": "Zoeken:",
          "emptyTable": "Geen resultaten aanwezig in de tabel",
          "infoThousands": ".",
          "loadingRecords": "Een moment geduld aub - bezig met laden...",
          "paginate": {
            "first": "Eerste",
            "last": "Laatste",
            "next": "Volgende",
            "previous": "Vorige"
          },
          "aria": {
            "sortAscending": ": activeer om kolom oplopend te sorteren",
            "sortDescending": ": activeer om kolom aflopend te sorteren"
          },
          "autoFill": {
            "fill": "Vul alle cellen met <i>%d<\/i>",
            "fillHorizontal": "Vul cellen horizontaal",
            "fillVertical": "Vul cellen verticaal"
          },
          "buttons": {
            "collection": "Collectie",
            "colvis": "Kolom zichtbaarheid",
            "colvisRestore": "Herstel zichtbaarheid",
            "copy": "Kopieer",
            "copySuccess": {
              "1": "1 regel naar klembord gekopieerd",
              "_": "%ds regels naar klembord gekopieerd"
            },
            "copyTitle": "Kopieer naar klembord",
            "csv": "CSV",
            "excel": "Excel",
            "pageLength": {
              "-1": "Toon alle regels",
              "_": "Toon %d regels"
            },
            "pdf": "PDF",
            "print": "Print"
          },
          "info": "_START_ tot _END_ van _TOTAL_ regels",
          "infoFiltered": " (gefilterd uit _MAX_ regels)",
          "processing": "Verwerken..."
        },
        pageLength: 25,

      },
    };
  },
  computed: {
    ...mapGetters('dockSuggestions', ['getDockSuggestions']),
    ...mapGetters('users', ['getMeBasic', 'getMyDepartments']),
  },
  methods: {
    async printTable() {
      this.$store.commit('setLoading', true);


      await this.$FB.collection('print-dock-suggestions-queue').add({
        created_at: new Date(),
        created_by: this.getMeBasic.userId,
        companyId: this.getMeBasic.companyId,
        location: this.currentView,
        date: this.selectedDate,
        data: JSON.stringify($('#dock-suggestions-dt').DataTable().rows({
          order: 'index',
          search: 'applied'
        }).data().toArray()),
        translatedColumns: {
          truck: this.$t('shopfloor.teamlead.dockSuggestions.truck'),
          trailer: this.$t('shopfloor.teamlead.dockSuggestions.trailer'),
          reference: this.$t('shopfloor.teamlead.dockSuggestions.reference'),
          etd: this.$t('shopfloor.teamlead.dockSuggestions.etd'),
          eta: this.$t('shopfloor.teamlead.dockSuggestions.eta'),
          suggestionOne: this.$t('shopfloor.teamlead.dockSuggestions.suggestionOne'),
          suggestionTwo: this.$t('shopfloor.teamlead.dockSuggestions.suggestionTwo')
        }
      });
      this.$store.commit('setLoading', false)
      return this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        type: 'success',
        title: this.$t('shopfloor.teamlead.dockSuggestions.printing')
      });
    },
    async getAllUsers() {

      let users = await this.$CLOUD_API.get(process.env.VUE_APP_CLOUD_API + '/users')
      // let users = await this.$CLOUD_API.get('http://127.0.0.1:5114/motivate-inventory-management/europe-west1/http_http/users')

      this.users = _.filter(users.data, user => {
        console.log(user)
        return !user.userData.leaveDate || moment(user.userData.leaveDate).isAfter(moment())
      })
      return users
    },
    async openDockSuggestionsDBChannel(date) {
      let skipCloseDB = false;
      if (!date) {
        date = moment();
        skipCloseDB = true;
      }
      if (!skipCloseDB) {
        await this.$store.dispatch('dockSuggestions/closeDBChannel', {clearModule: true});
      }

      let where = [['companyId', '==', this.getMeBasic.companyId]]
      where.push(['date', '==', date.format('YYYY-MM-DD')]);
      where.push(['location', '==', this.currentView]);

      await this.$store.dispatch('dockSuggestions' + '/openDBChannel', {where})

      this.$store.commit('setLoading', false)

      this.viewTriggers++;
    },
    getColumns() {
      let self = this;
      return [
        {
          data: null,
          name: this.$t('shopfloor.teamlead.users.name'),
          searchable: true,
          className: 'alignCenter',
          width: '20%',
          sortable: true,
          visible: true,
          render(data) {
            return data.userData.name;
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.users.usernumber'),
          searchable: true,
          className: 'alignCenter',
          width: '5%',
          sortable: true,
          visible: true,
          render(data) {
            return data.userData.code;
          }
        },
        // {
        //   data: null,
        //   name: this.$t('shopfloor.teamlead.users.beschrijving'),
        //   searchable: true,
        //   className: 'alignCenter',
        //   sortable: true,
        //   visible: true,
        //   render(data) {
        //     return data.userData.name;
        //   }},
        {
          data: null,
          name: this.$t('shopfloor.teamlead.users.position'),
          searchable: true,
          width: '5%',
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data.userData.description;
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.users.rights'),
          searchable: true,
          width: '5%',
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            let companyIds = _.map(data.userData.possibleCompanies, c => {
              return c.companyId
            })

            let accesTo = _.filter(self.getMyDepartments, dep => {

              return _.includes(companyIds, dep.value)

            })
            return _.map(accesTo, dep => {
              return dep.label
            })
          }

        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.users.leaveDate'),
          searchable: true,
          className: 'alignCenter',
          width: '5%',
          sortable: true,
          visible: true,
          render(data) {

            return data.userData.leaveDate ? moment(data.userData.leaveDate).format('DD-MM-YYYY') : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.users.lastLogin'),
          searchable: true,
          className: 'alignCenter',
          width: '5%',
          sortable: true,
          visible: true,
          render(data) {
            return data.metadata.lastSignInTime ? moment(data.metadata.lastSignInTime).format('DD-MM-YYYY HH:mm:ss') : '';
          }
        },

      ]
    },
    async closeView(to) {
      return this.$store.dispatch('dockSuggestions/closeDBChannel', {clearModule: true});
    }
    ,
    // async createView() {
    //   this.selectedRows = [];
    //   this.selectedDate = new Date();
    //   // this.currentView = this.$route.meta['view'];
    //   this.currentView = localStorage.getItem('orderhandling-view')
    //
    //   return this.openDockSuggestionsDBChannel();
    // }
  },
  watch: {},
  async beforeRouteLeave(to, from, next) {
    // await this.closeView(to);
    next();
  },
  async created() {
    this.$store.commit('setLoading', true)
    await this.getAllUsers()
    // this.createView();
    this.$store.commit('setLoading', false)
  }
};
</script>


<style lang="scss">
.status-loading-idle {
  background-color: #ffa0a0;
}

.status-loading-busy {
  background-color: #ffaf46;
}

.status-loading-done {
  background-color: #00b954;
}


.status-unloading-idle {
  background-color: white;
  border: 1px solid black !important;
}

.status-unloading-busy {
  background-color: gray;
}

.status-unloading-done {
  background-color: #00c9ff;
}

.circle {
  width: 2rem;
  height: 2rem;
  border: 1px solid white;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50px;
}

.align-right-div {
  text-align: right;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.state-filter {
  display: grid;
  grid-template-columns: 13rem 2rem;;
  grid-template-rows: auto;
  grid-column-gap: 1rem;
  grid-row-gap: 0px;
}

.selection-buttons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 0px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.dataTable-filters {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  margin: 1rem;
  margin-left: 0rem;
  margin-right: 0rem;
}

.percentage {
  font-weight: normal !important;
}

.m-hide-lg {
  visibility: hidden;
  height: 0px;
}

.container-fluid {
  margin-bottom: 15px;
}

.reset-filter-button {
  margin-right: 1rem;
}

.blink-button {
  -webkit-animation: blink 5s infinite; /* Safari 4+ */
  -moz-animation: blink 5s infinite; /* Fx 5+ */
  -o-animation: blink 5s infinite; /* Opera 12+ */
  animation: blink 5s infinite; /* IE 10+, Fx 29+ */
}


.print-button {
  width: 5rem;
  height: 5rem;
  padding: 0;
  align-self: center;
  border-radius: 4px;
  justify-self: end;
}
</style>



